import DeleteWorkspace from "./DeleteWorkspace";
import WorkspaceName from "./WorkspaceName";
import WorkspacePicture from "./WorkspacePicture";

export default function General() {
  return (
    <div>
      <WorkspacePicture />
      <WorkspaceName />
      <DeleteWorkspace />
    </div>
  );
}
